'use client'

import React from 'react'
import ReactPlayer from 'react-player'

type Props = { readonly videoLink: string }

const ListHeaderVideo: React.FC<Props> = ({ videoLink }) => {
  return (
    <div className="relative w-full flex-shrink-0 pt-[56.25%] big-tablet:max-w-[440px] big-tablet:pt-0">
      <ReactPlayer
        src={videoLink}
        className="absolute left-0 top-0 overflow-hidden rounded-xl"
        controls
        width="100%"
        height="100%"
      />
    </div>
  )
}

export default ListHeaderVideo
